<template>
  <div class="moduleTutorialWrap">
    <div class="content">
      <p class="title">{{ $t('lang.k_238001') }}</p>
      <div class="content-container">
        <article class="valueItem">
          <p class="itemTitle"></p>
          <p class="itemValue">{{ $t('lang.k_238002') }}</p>
        </article>
        <article class="valueItem">
          <p class="itemTitle"></p>
          <p class="itemValue">{{ $t('lang.k_238003') }}</p>
        </article>
      </div>
    </div>
  </div>
</template>

<script>
  export default {};
</script>

<style lang="less" scoped>
  .moduleTutorialWrap {
    background-image: url(../images/vodresetbg.png);
    background-size: cover;
    height: 500px;
    border-radius: 8px;
  }
  .content {
    padding: 185px 0 0 455px;
    .title {
      min-width: 95px;
      height: 24px;
      background: #fb3d32;
      border-radius: 12px;
      color: #ffffff;
      line-height: 24px;
      font-size: 16px;
      text-align: center;
      display: inline-block;
      padding: 0 10px;
    }

    .content-container {
      position: absolute;
      top: 250px;
      width: 230px;
      bottom: 20px;
      overflow: auto;
      overflow-x: hidden;
      pointer-events: initial;
      white-space: normal;
      word-break: break-word;
      overflow-wrap: break-word;
    }

    .valueItem {
      .itemTitle {
        width: 33px;
        height: 3px;
        margin-top: 22px;
        // background-image: linear-gradient(to right, color-stop1, color-stop2);

        background: linear-gradient(270deg, rgba(255, 255, 255, 0.2) 0%, #fb3b32 100%);
      }
      .itemValue {
        width: 230px;
        padding-top: 10px;
        font-size: 14px;
        font-weight: 500;
        color: #000000;
        line-height: 20px;
      }
    }
  }
</style>
